import { UserType } from '@centecomm/portal-service';
import { IconProps } from 'Icons/IconProps';
import React from 'react';
import { RiBankCardLine } from 'react-icons/ri';
import { LaunchDarklyFlags } from 'utils/Hooks/LaunchDarkly/launchDarklyFlags';

import { FeatureConfiguration } from '../../Core/Types/FeatureConfiguration';
import { LoadingContent } from '../../Shared/PageElements/LoadingContent';

const LazyOwnerOperatorPaymentsLandingPage = React.lazy(() => import('./Pages/OwnerOperatorPaymentsLandingPage'));

const paymentsMarketingConfiguration: FeatureConfiguration = {
    name: 'PaymentsMarketing',
    navigationItem: {
        route: {
            text: 'common:sidebar.featurePaymentsTitle',
            url: '/payments',
            Icon: ({ color, aspect }: IconProps) => <RiBankCardLine size={aspect} color={color} />,
            badgeText: 'common:sidebar.newBadge',
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyOwnerOperatorPaymentsLandingPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        // Visibility is governed entirely by `visibilityRule`; opening the permission
        // gate keeps that rule the single source of truth for this promotional page.
        isGloballyAccessible: true,
        permissions: [],
    },
    disableFeature: [],
    // Owner-operators who have opted into the marketing flag but do not yet have
    // the real Payments feature turned on: OwnerOperator AND payments-marketing AND NOT payments.
    visibilityRule: {
        userType: UserType.OwnerOperator,
        [LaunchDarklyFlags.PaymentsMarketing]: true,
        [LaunchDarklyFlags.Payments]: { $ne: true },
    },
};

export default paymentsMarketingConfiguration;
